import { formatDistanceToNowStrict } from 'date-fns'

/**
 * @param pastDate - '2020-11-17T11:21:51.000Z'
 * @returns relative time ago - '1 month ago'
 */
export const formatRelativeTimeAgo = (pastDate: string | Date) => {
  const d = typeof pastDate === 'string' ? new Date(pastDate) : pastDate
  return `${formatDistanceToNowStrict(d)} ago`
}
